import * as React from "react"

import { cn } from "@utils/utils"
import * as LabelPrimitive from "@radix-ui/react-label"
import { getSuggestedCharCountColor, isOverSuggestedCharCount } from "@shared/utils/charCount.utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  showCharCount?: boolean;
  minLength?: number;
  suggestedMaxLength?: number;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, id, error, showCharCount, minLength, suggestedMaxLength, value, ...props }, ref) => {
    const charCount = typeof value === 'string' ? value.length : 0;
    const isValid = minLength ? charCount >= minLength : true;
    const suggestedColor = suggestedMaxLength ? getSuggestedCharCountColor(charCount, suggestedMaxLength) : undefined;
    const isOverSuggested = suggestedMaxLength ? isOverSuggestedCharCount(charCount, suggestedMaxLength) : false;
    return (
      <div className="space-y-2">
        {label && (
          <LabelPrimitive.Root
            htmlFor={id}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {label}
          </LabelPrimitive.Root>
        )}
        {suggestedMaxLength ? (
          <div className="flex justify-between items-center">
            <span className="text-xs transition-colors duration-300" style={{ color: suggestedColor }}>
              {charCount}/{suggestedMaxLength} caracteres sugeridos
            </span>
          </div>
        ) : showCharCount && minLength && (
          <div className="flex justify-between items-center">
            <span className={`text-xs ${isValid ? 'text-green-600' : 'text-muted-foreground'}`}>{charCount}/{minLength} caracteres mínimos</span>
          </div>
        )}
        <textarea
          id={id}
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            error ? "border-red-500" : "",
            className
          )}
          ref={ref}
          value={value}
          {...props}
        />
        {isOverSuggested && (
          <p className="text-xs transition-colors duration-300" style={{ color: suggestedColor }}>
            No es recomendable un texto de esta longitud.
          </p>
        )}
        {error && (
          <p className="text-sm text-red-600 mt-1">{error}</p>
        )}
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea } 